var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, IconButton } from '@mui/material';
import { COMPONENT_ID_ENUM } from './types';
var Navbar = function (_a) {
    var _b, _c;
    var isCourseOverviewAvailable = _a.isCourseOverviewAvailable, isScholarshipDataAvailable = _a.isScholarshipDataAvailable, isAcademicRequirementsDataAvailable = _a.isAcademicRequirementsDataAvailable, isSimilarCoursesDataAvailable = _a.isSimilarCoursesDataAvailable, isSimilarStudentsDataAvailable = _a.isSimilarStudentsDataAvailable, isEnglishExamDataAvailable = _a.isEnglishExamDataAvailable, isAdditionalExamDataAvailable = _a.isAdditionalExamDataAvailable, isApplicationFilingRequirementsDataAvailable = _a.isApplicationFilingRequirementsDataAvailable;
    var sections = (_b = [
        isCourseOverviewAvailable && {
            label: 'Course Overview',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_OVERVIEW
        },
        isScholarshipDataAvailable && {
            label: 'Financial Aid & Scholarships',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_SCHOLARSHIP
        },
        isAcademicRequirementsDataAvailable && {
            label: 'Academic Requirements',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_ACADEMIC_REQUIREMENT
        },
        isApplicationFilingRequirementsDataAvailable && {
            label: 'Application Filing Requirements',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_APPLICATION_FILING_REQUIREMENTS
        },
        isEnglishExamDataAvailable && {
            label: 'English Exam Requirements',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_ENGLISH_EXAM_REQUIREMENT
        },
        isAdditionalExamDataAvailable && {
            label: 'Additional Requirements',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_ADDITIONAL_REQUIREMENT
        },
        isSimilarCoursesDataAvailable && {
            label: 'Similar Courses',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_SIMILAR_COURSES
        },
        isSimilarStudentsDataAvailable && {
            label: 'Students enrolled in this Institute',
            elementId: COMPONENT_ID_ENUM.COURSE_DETAILS_SIMILAR_STUDENTS
        }
    ]) === null || _b === void 0 ? void 0 : _b.filter(function (section) { return !!section; });
    var scrollRef = useRef(null);
    var scroll = function (direction) {
        if (scrollRef.current) {
            var _a = scrollRef.current, scrollLeft = _a.scrollLeft, clientWidth = _a.clientWidth;
            var scrollAmount = direction === 'left' ? -clientWidth : clientWidth;
            scrollRef.current.scrollTo({
                left: scrollLeft + scrollAmount,
                behavior: 'smooth'
            });
        }
    };
    var _d = __read(useState(false), 2), isAtLeftEnd = _d[0], setIsAtLeftEnd = _d[1];
    var _e = __read(useState(false), 2), isAtRightEnd = _e[0], setIsAtRightEnd = _e[1];
    var handleScroll = function () {
        if (scrollRef.current) {
            var _a = scrollRef.current, scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
            setIsAtLeftEnd(scrollLeft === 0);
            setIsAtRightEnd(scrollLeft + clientWidth >= scrollWidth);
        }
    };
    useEffect(function () {
        var ref = scrollRef.current;
        if (ref) {
            ref.addEventListener('scroll', handleScroll);
            handleScroll();
            return function () {
                ref.removeEventListener('scroll', handleScroll);
            };
        }
        return function () { };
    }, []);
    var _f = __read(useState((_c = sections[0]) === null || _c === void 0 ? void 0 : _c.elementId), 2), activeSection = _f[0], setActiveSection = _f[1];
    useEffect(function () {
        var handleScrollV2 = function () {
            var _a;
            var currentSection = '';
            var currentIndex;
            sections.forEach(function (section, index) {
                if (!section)
                    return;
                var sectionElement = document.getElementById(section === null || section === void 0 ? void 0 : section.elementId);
                if (sectionElement) {
                    var sectionTop = sectionElement.offsetTop - 124;
                    var sectionHeight = sectionElement.clientHeight;
                    if (window.pageYOffset >= sectionTop && window.pageYOffset < sectionTop + sectionHeight) {
                        currentSection = section.elementId;
                        currentIndex = index;
                    }
                }
            });
            if (currentIndex === 0) {
                (_a = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: 0 });
            }
            // if (currentIndex === sections?.length - 2) {
            //   scrollRef?.current?.scrollBy({ left: 1000 });
            // }
            if (currentSection) {
                setActiveSection(currentSection);
            }
        };
        window.addEventListener('scroll', handleScrollV2);
        return function () {
            window.removeEventListener('scroll', handleScrollV2);
        };
    }, []);
    var handleClick = function (e) {
        e.preventDefault();
    };
    useEffect(function () {
        if (activeSection) {
            var activeLink = document.querySelector("a[href=\"#".concat(activeSection, "\"]"));
            if (activeLink && scrollRef.current) {
                var navWidth = scrollRef.current.offsetWidth;
                var linkLeft = activeLink.offsetLeft;
                var linkWidth = activeLink.offsetWidth;
                if (linkLeft + linkWidth > navWidth) {
                    scrollRef.current.scrollLeft = linkLeft - navWidth + linkWidth;
                }
                else if (linkLeft < scrollRef.current.scrollLeft) {
                    scrollRef.current.scrollLeft = linkLeft;
                }
            }
        }
    }, [activeSection]);
    return (React.createElement("div", { className: "lfc-w-full lfc-bg-white lfc-p-4 lfc-rounded-lg" },
        React.createElement(Box, { sx: {
                position: 'relative',
                maxWidth: '100%',
                zIndex: 2,
                pl: isAtLeftEnd ? 2 : 6,
                pr: isAtRightEnd ? 2 : 6
            } },
            React.createElement(React.Fragment, null,
                !isAtLeftEnd && (React.createElement(IconButton, { onClick: function () {
                        scroll('left');
                    }, size: "small", className: "lfc-absolute lfc-shadow-lg lfc-z-[500] lfc-bottom-[50%] lfc-translate-y-[50%] lfc--left-[8px] lfc-bg-primary-100 lfc-rounded-full" },
                    React.createElement(KeyboardArrowLeftIcon, null))),
                !isAtRightEnd && (React.createElement(IconButton, { size: "small", onClick: function () {
                        scroll('right');
                    }, className: "lfc-absolute lfc-shadow-lg lfc-z-[500] lfc-bottom-[50%] lfc-translate-y-[50%] lfc--right-[8px] lfc-bg-primary-100 lfc-rounded-full" },
                    React.createElement(KeyboardArrowRightIcon, null)))),
            React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-x-2 lfc-w-full lfc-overflow-x-scroll", id: COMPONENT_ID_ENUM.COURSE_DETAILS_NAVBAR, ref: scrollRef },
                React.createElement("div", { className: "lfc-flex lfc-gap-x-6 lfc-min-w-fit lfc-w-full" }, sections === null || sections === void 0 ? void 0 : sections.map(function (section, index) {
                    if (!section)
                        return null;
                    return (React.createElement("a", { key: section === null || section === void 0 ? void 0 : section.label, href: "#".concat(section.elementId), onMouseEnter: function (e) {
                            e.preventDefault();
                        }, onClick: function (e) {
                            handleClick(e);
                        }, className: "lfc-min-w-fit ".concat(activeSection === section.elementId ? 'lfc-text-primary-500' : '') },
                        React.createElement(GBTypography, { key: section === null || section === void 0 ? void 0 : section.label, variant: "sh2Semibold", className: "lfc-text-grey-700 lfc-min-w-fit lfc-cursor-pointer ".concat(activeSection === section.elementId ? 'lfc-text-primary-500' : 'lfc-text-grey-700'), onClick: function () {
                                var element = document === null || document === void 0 ? void 0 : document.getElementById(section === null || section === void 0 ? void 0 : section.elementId);
                                var elementPosition = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top;
                                var offsetPosition = (elementPosition || 0) + window.pageYOffset - 124;
                                if (index === (sections === null || sections === void 0 ? void 0 : sections.length) - 1) {
                                    setActiveSection(section === null || section === void 0 ? void 0 : section.elementId);
                                }
                                scrollTo({
                                    top: offsetPosition,
                                    behavior: 'smooth'
                                });
                            } }, section === null || section === void 0 ? void 0 : section.label),
                        activeSection === (section === null || section === void 0 ? void 0 : section.elementId) ? (React.createElement("div", { className: "lfc-h-0.5 lfc-bg-primary-500 lfc-rounded-lg" })) : null));
                }))))));
};
export default Navbar;
//# sourceMappingURL=Navbar.js.map